export const CREATE_CIVIL_LOW_FORM_NAME = {
	bin: 'bin',
	beginDate: 'beginDate',
	companyName: 'companyName',
	companyNameKaz: 'companyNameKaz',
	contractDate: 'contractDate',
	contractNumber: 'contractNumber',
	dcountryCode: 'dcountryCode',
	ddistrictCode: 'ddistrictCode',
	dlocalityCode: 'dlocalityCode',
	dpaymentScheduleCode: 'dpaymentScheduleCode',
	dpositionCode: 'dpositionCode',
	dregionCode: 'dregionCode',
	dremoteWorkCode: 'dremoteWorkCode',
	endDate: 'endDate',
	establishedPostKz: 'establishedPostKz',
	establishedPostRu: 'establishedPostRu',
	externalId: 'externalId',
	fullName: 'fullName',
	id: 'id',
	iin: 'iin',
	serviceDescriptionKz: 'serviceDescriptionKz',
	serviceDescriptionRu: 'serviceDescriptionRu',
	totalPaymentAmount: 'totalPaymentAmount',
	workPlace: 'workPlace',
	contractEndDate: 'contractEndDate',
	subsidiaryContractNumber: 'subsidiaryContractNumber',
	subsidiaryContractDate : 'subsidiaryContractDate',
}

export const TERMINATE_CIVIL_LOW_FORM_NAME = {
	contractId: 'contractId',
	terminationDate: 'terminationDate',
	terminationReasons: 'terminationReasons',
}

export const CIVIL_LOW_TYPES = {
	create: 'create',
	view: 'view',
	edit: 'edit',
	delete: 'delete',

	terminate: 'terminate',
	terminate_accept: 'terminate_accept',

	create_add_contract: 'create_add_contract',
	edit_add_contract: 'edit_add_contract',
	delete_add_contract: 'delete_add_contract',
	view_add_contract: 'view_add_contract',
}